import type { State } from 'src/replicant/State';
import type { StateHistoryRecord } from './history.schema';
import type { HistoryRecord } from './history.ruleset';
import type { PetSpeciesID } from '../pet';

/**
 * Return history records
 */
export function getHistory(state: State): HistoryRecord[] {
  return [...state.history] as StateHistoryRecord[] as HistoryRecord[];
}

/**
 * Get all raised pets statistics
 *
 * @returns {Partial<Record<PetSpeciesID, number>>} - object with species id as key and number of raised pets as value
 */
export function getRaisedPetsHistory(
  state: State,
): Partial<Record<PetSpeciesID, number>> {
  const history = getHistory(state);
  const result: Partial<Record<PetSpeciesID, number>> = {};
  const currentEvolutions = [...state.pet.evolutions];

  // Remove current evolution,
  // The species that you haven’t made evolve or debut should not be counted to be raised
  currentEvolutions.pop();

  for (const record of history) {
    if (record.type === 'death' || record.type === 'duo') {
      const { evolutions } = record;
      const species: PetSpeciesID[] = evolutions.map(
        (evolution) => evolution.species,
      );

      species.forEach((species) => {
        result[species] = (result[species] ?? 0) + 1;
      });
    }
  }

  // Add past evolutions
  for (const evolution of currentEvolutions) {
    result[evolution.species] = (result[evolution.species] ?? 0) + 1;
  }

  return result;
}
